export default "__VITE_ASSET__775eea08__"